import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { assistantApi } from "./api";
import { ASSISTANT_QUERY_KEY } from "./constants";

export function useAssistantConversations() {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ASSISTANT_QUERY_KEY,
    queryFn: assistantApi.listConversations,
  });
  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: ASSISTANT_QUERY_KEY });

  const createMutation = useMutation({
    mutationFn: assistantApi.createConversation,
    onSuccess: invalidate,
  });
  const removeMutation = useMutation({
    mutationFn: assistantApi.deleteConversation,
    onSuccess: invalidate,
  });

  return {
    conversations: query.data ?? [],
    isLoading: query.isLoading,
    create: () => createMutation.mutateAsync(),
    remove: (id: number) => removeMutation.mutateAsync(id),
  };
}

export function useAssistantConversation(id: number | null) {
  return useQuery({
    queryKey: ["assistant", "conversation", id],
    queryFn: () => assistantApi.getConversation(id as number),
    enabled: id !== null,
  });
}
